import { Component, OnInit } from '@angular/core';
import { replaceBrowserUrlWithAuthCallback } from './utils/auth-callback-url';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'resultpage';

  ngOnInit(): void {
    replaceBrowserUrlWithAuthCallback();
  }
}
